import React, { useState } from 'react';
import { Button, DataGrid } from 'devextreme-react';
import { Export, ColumnChooser, ColumnFixing, Pager, Column } from 'devextreme-react/data-grid';
import { TagBoxSucursales, TagBoxAreas, TextBoxEvaluations, CreeateHeadersGeneralForms, RenderHeader, CellRenderDtForm } from '../../components/ReportTasks/ReportTasks'
import * as Fnctn from '../../contexts/GenericFunctions'
import { DataGridTypes, SearchPanel } from "devextreme-react/data-grid"
import 'bootstrap/dist/css/bootstrap.min.css';
import { halcoloaderActive, halcoloaderRemove } from '../../contexts/HalcoLoader';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';

function ReportGeneraEvaluations() {

  const [codeSucursales, setCodeSucursales] = useState<any>();
  const [codeAreas, setCodeAreas] = useState<any>();
  const [codeEvaluacion, setCodeEvaluacion] = useState<any>();
  const [nameEvaluacion, setNameEvaluacion] = useState<any>();
  const [dgvDatos, setDgvDatos] = useState<any>();
  const [visibleDgvDatos, setVisibleDgvDatos] = useState<boolean>();

  const getIds = (list: any, tb: string) => {
    if (tb === "sucursales") setCodeSucursales(list);
    else if (tb === "areas") setCodeAreas(list);
    else if (tb === "Evaluaciones") setCodeEvaluacion(list);
  }

  const getEvaluationName = (list: any, tb: string) => {
    setNameEvaluacion(list);
  }

  const onExporting = (e: DataGridTypes.ExportingEvent) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Respuestas');

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `Resultados de ${nameEvaluacion}.xlsx`);
      });
    });
  };

  const Consultar = async () => {
    halcoloaderActive();
    let columns: any = [];
    let nwDataArray: any[] = [];
    let api = Fnctn.GetAPI();
    let data = Fnctn.getCookie();

    let ObjtEvaluations: any = {
      "id_evaluacion": codeEvaluacion,
      "code_branches": codeSucursales,
      "ids_areas": codeAreas,
      "cvetra": []
    };

    let dtEvaluations: any = await fetch(`${api}/reports/medicion_evaluaciones?filter_cvetra=false`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${data.token}`
      },
      body: JSON.stringify(ObjtEvaluations)
    });

    dtEvaluations = await dtEvaluations.json();

    let dtResultHerarchy: any = await fetch(`${api}/reports/herarchy_result`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${data.token}`
      },
      body: JSON.stringify({ job_code: data.job_code })
    });

    dtResultHerarchy = await dtResultHerarchy.json();
    nwDataArray = dtEvaluations.data;

    if (data.data_role[0]._id === "66033f424c474d37bd058975") {
      nwDataArray = [];
      for (let i: number = 0; i < dtResultHerarchy.data.length; i++) {
        let result = dtEvaluations.data.filter((item: any) => item.employee_cvetra === dtResultHerarchy.data[i].cvetra)
        if (result.length > 0) nwDataArray.push(result[0]);
      }
    }

    columns = CreeateHeadersGeneralForms(nwDataArray[0]);


    setDgvDatos(
      <DataGrid
        className='dgvResultados'
        dataSource={nwDataArray}
        height="650px"
        width="100%"
        style={{ "fontSize": "5px" }}
        rowAlternationEnabled={false}
        allowColumnReordering={true}
        allowColumnResizing={true}
        showBorders={true}
        onExporting={onExporting}
      >
        <SearchPanel
          visible={true}
          width={240}
          placeholder="Buscar" />
        <ColumnChooser enabled={true} />
        <ColumnFixing enabled={true} />
        <Column dataField={"employee_cvetra"} caption={'Num Empleado'} visible={true} width={"auto"} fixed={true}></Column>
        <Column dataField={"employee_name"} caption={'Nombre'} visible={true} width={"auto"} fixed={true}></Column>
        <Column dataField={"total_points"} caption={'Puntos totales'} visible={true} width={"auto"} fixed={true}></Column>
        <Column dataField={"totals_obtained"} caption={'Puntos Obtenidos'} visible={true} width={"auto"} fixed={true}></Column>
        {
          columns.map((column: any, index: any) => (
            <Column
              {...column}
              allowSorting={true}
              key={index}
              customProperty={column.ResponseType}
              headerCellRender={RenderHeader}
              cellRender={(e) => CellRenderDtForm(e)}
              alignment='left'
              width={"200"}
            />
          ))
        }
        <Export enabled={true} allowExportSelectedData={true} />
        <Pager showPageSizeSelector={true} allowedPageSizes={nwDataArray.length > 1000 ? [100, 150, 1000] : [100, 150, 'all']} />
      </DataGrid>
    );
    setVisibleDgvDatos(true);
    halcoloaderRemove();
  };

  return (
    <React.Fragment>
      <div className={'content-block dx-card responsive-paddings'} style={{ margin: "30px 0px 30px 45px", width: "95%" }}>
        <div className='row' style={{ display: "flex" }}>
          <div className='col-md-3'>
            <TextBoxEvaluations getIds={getIds} getEvaluationName={getEvaluationName}></TextBoxEvaluations>
          </div>
          <div className='col-md-3'>
            <TagBoxSucursales getIds={getIds}></TagBoxSucursales>
          </div>
          <div className='col-md-3'>
            <TagBoxAreas getIds={getIds}></TagBoxAreas>
          </div>
          <div className='col-md-3'>
            <Button
              className='btnConsultar'
              stylingMode='contained'
              text='Consultar'
              onClick={() => Consultar()}
            ></Button>
          </div>
        </div>
        {visibleDgvDatos && dgvDatos}
      </div>
    </React.Fragment>
  )
}

export default ReportGeneraEvaluations; 